import {store} from "../../NextApp";

import {
  FETCH_SPARE_INVENTORY_FILTER,
  FETCH_SPARE_INVENTORY_SUCCESS,
  RESET_SPARE_INVENTORY,
  SPARE_PART_BALANCE_SUCCESS
} from "../../constants/ActionTypes";

import axios from "util/Api";
import {fetchError, fetchStart, fetchSuccess} from "./Common";
import {message} from "antd";
import moment from "moment";

export const getDataSuccess = (inventories) => {
  return {
    type: FETCH_SPARE_INVENTORY_SUCCESS,
    inventories,
  };
};

export const getFilterSuccess = (sparePartTypes, locations, subLocations) => {
  return {
    type: FETCH_SPARE_INVENTORY_FILTER,
    spareParts: [],
    sparePartTypes,
    locations,
    subLocations
  };
};

export const resetInventorySuccess = () => {
  return {
    type: RESET_SPARE_INVENTORY,
  };
};

export const resetInventory = () => {
  return async dispatch => {
    dispatch(resetInventorySuccess());
  };
};

export const getSpareInventoryFilters = () => {
  return async dispatch => {
    dispatch(fetchStart());

    const locations = await axios.get(`/location`);
    const subLocations = await axios.get(`/client`);
    // const spareParts = await axios.get(`/spare-part`);
    const sparePartTypes = await axios.get(`/spare-part-type`);

    if(locations && subLocations && sparePartTypes) {
      dispatch(getFilterSuccess(sparePartTypes.data, locations.data, subLocations.data));
      dispatch(fetchSuccess());
    } else {
      message.error('Loading data missing!');
      dispatch(fetchError('Loading data missing!'));
      console.log("Error****:", 'Loading data missing!');
    }
  };
};

export const spareBalanceSuccess = (balance) => {
  return {
    type: SPARE_PART_BALANCE_SUCCESS,
    balance
  };
};

export const getSpareInventoryBalance = (payload) => {
  return async dispatch => {
    // const {spareInventoryReport} = store.getState();
    const {spare, location, date, subLocation} = payload;
    // const date = moment().format('YYYY-MM-DD');
    if(spare && location) {
      dispatch(fetchStart());
      return axios
        .get(`/common/report/spare-balance/${spare}/${date ? moment(date).valueOf() : moment().valueOf()}/${location}`, {
          params: subLocation ? {subLocation} : {},
        })
        .then(async result => {
          if(result && result.data) {
            return processBalanceData(result.data).then(data => {
              const processedBalance = data.map(d => {
                return {_id: d._id, name: d.name, total: d.total, spare}
              });
              dispatch(spareBalanceSuccess(processedBalance));
              dispatch(fetchSuccess());
              return processedBalance;
            });
          } else {
            message.error('No Data found');
            dispatch(fetchError('No data found'));
            return [];
            // dispatch(getDataSuccess([]));
          }
        })
        .catch(error => {
          if(error.response && error.response.data) {
            message.error(error.response && error.response.data && error.response.data.message);
          } else {
            message.error(error);
          }
          dispatch(fetchError(error.response && error.response.data && error.response.data.message || error));
          console.log("Error****:", error.response);
          throw error;
        });
    }
    return [];
  };
};


function processBalanceData(dataObjects) {
  return new Promise((resolve, _) => {
    const {data, clients} = dataObjects;
    const closingData = (data || [])
      .filter(doc => doc.direction === 'closing')
      .map(doc => {
        const bal = {
          subLocation: doc.subLocation,
          close_quantity: doc.close_quantity,
          spare: doc.spare,
        };
        if(!doc.subLocation || doc.subLocation === undefined || doc.subLocation === null) {
          delete bal.subLocation
        }
        return bal;
      }).reduce((result, currentValue) => {
        result[currentValue['subLocation']] = result[currentValue['subLocation']] ?
          (result[currentValue['subLocation']] + parseFloat(currentValue['close_quantity'])) :
          parseFloat(currentValue['close_quantity']);
        return result;
      }, {});

    const balProm = Object.entries(closingData).map(async ([k, v]) => {
      let name = '';
      if(k) {
        const client = clients.filter(cl => cl._id === k);
        if(client && client.length > 0) {
          name = client[0] && client[0].name;
        }
      }
      return {
        _id: (k && k !== 'undefined') ? k.toString() : null,
        name,
        total: v || 0,
      }
    });
    Promise.all(balProm).then(doc => resolve(doc));
  })
}

export const getSpareInventory = (payload) => {
  return async dispatch => {
    dispatch(fetchStart());
    const {spareInventoryReport} = store.getState();
    axios
      .post(`/common/report/spare-inventory`, payload)
      .then(async result => {
        const {locations: locationMaster, subLocations: subLocationMaster} = spareInventoryReport;
        if(result && result.data && result.data.length > 0 && result.data.filter(x => x !== null).length > 0 && locationMaster && subLocationMaster) {
          processData(result.data, locationMaster, subLocationMaster).then(data => {
            dispatch(fetchSuccess());
            dispatch(getDataSuccess(data))
          });
        } else {
          message.error('No Data found');
          dispatch(fetchError('No data found'));
          dispatch(getDataSuccess([]));
        }
      })
      .catch(error => {
        message.error(error.response.data.message);
        dispatch(fetchError(error.response.data.message));
        console.log("Error****:", error.response);
      });
  };
};

function processData(data, locationMaster, subLocationMaster) {
  return new Promise((resolve, reject) => {

    const mainDoc = data.map((doc, index) => {
      return groupBy(doc.inventory, 'location')
        .then(locationSpares => {

          const locationChildren = Object.keys(locationSpares).map((lcId, i) => {
            const lc = locationSpares[lcId];
            const locationObj = locationMaster.data.filter(l => l._id.toString() === lcId.toString());

            const subLocations = (lc[0] && lc[0].length > 0) ? lc[0] : [];

            const subPrm = groupBy(subLocations, 'subLocation')
              .then(subLocationSpares => {

                return Object.keys(subLocationSpares).map((slcId, j) => {
                  const slc = subLocationSpares[slcId];
                  const sLocationObj = subLocationMaster.data.filter(l => l._id.toString() === slcId.toString());

                  return processDetailRecords(slc, locationMaster, subLocationMaster, index + '-' + i + '-' + j)
                    .then(subDetail => {

                      return {
                        key: index + '-' + i + '-' + j,
                        sparePart: (doc.sparepart && doc.sparepart.name) || '-',
                        sparePartId: (doc.sparepart && doc.sparepart._id) || null,
                        sparePartType: (doc.sparepartType && doc.sparepartType.name) || '-',
                        unit: doc.unit || '-',
                        location: '-',
                        subLocation: (sLocationObj && sLocationObj[0] && sLocationObj[0].name) || '-',
                        openQty: slc.openQty || 0,
                        openRate: slc.openQty ? (slc.openRate && slc.openNos) ? (slc.openRate / slc.openNos) : 0 : 0,
                        openTotal: (slc.openRate && slc.openNos && slc.openQty) ? slc.openQty * (slc.openRate / slc.openNos) : 0,
                        inQty: slc.inQty || 0,
                        inRate: (slc.inRate && slc.inNos) ? (slc.inRate / slc.inNos) : 0,
                        inTotal: (slc.inRate && slc.inNos && slc.inQty) ? slc.inQty * (slc.inRate / slc.inNos) : 0,
                        outQty: slc.outQty || 0,
                        outRate: (slc.outRate && slc.outNos) ? (slc.outRate / slc.outNos) : 0,
                        outTotal: (slc.outRate && slc.outNos && slc.outQty) ? slc.outQty * (slc.outRate / slc.outNos) : 0,
                        closeQty: slc.closeQty || 0,
                        closeRate: slc.closeQty ? (slc.closeRate && slc.closeNos) ? (slc.closeRate / slc.closeNos) : 0 : 0,
                        closeTotal: (slc.closeRate && slc.closeNos && slc.closeQty) ? slc.closeQty * (slc.closeRate / slc.closeNos) : 0,
                        details: subDetail,
                        color: 'selected_sub_row'
                      }
                      // return processDetailRecords(slc, locationObj, subLocationMaster, index + '-' + i + '-' + j).then(detail => {
                      //   endChild['details'] = detail;
                      //   return endChild;
                      // })

                    })

                })
              })
            return Promise.resolve(subPrm).then(subLocDatas => {
              return Promise.all(subLocDatas).then(subChild => {
                let subData = {
                  key: index + '-' + i,
                  sparePart: (doc.sparepart && doc.sparepart.name) || '-',
                  sparePartId: (doc.sparepart && doc.sparepart._id) || null,
                  sparePartType: (doc.sparepartType && doc.sparepartType.name) || '-',
                  unit: doc.unit || '-',
                  location: (locationObj && locationObj[0] && locationObj[0].name) || '-',
                  subLocation: 'Total',
                  openQty: lc.openQty || 0,
                  openRate: lc.openQty ? (lc.openRate && lc.openNos) ? (lc.openRate / lc.openNos) : 0 : 0,
                  openTotal: (lc.openRate && lc.openNos && lc.openQty) ? lc.openQty * (lc.openRate / lc.openNos) : 0,
                  inQty: lc.inQty || 0,
                  inRate: (lc.inRate && lc.inNos) ? (lc.inRate / lc.inNos) : 0,
                  inTotal: (lc.inRate && lc.inNos && lc.inQty) ? lc.inQty * (lc.inRate / lc.inNos) : 0,
                  outQty: lc.outQty || 0,
                  outRate: (lc.outRate && lc.outNos) ? (lc.outRate / lc.outNos) : 0,
                  outTotal: (lc.outRate && lc.outNos && lc.outQty) ? lc.outQty * (lc.outRate / lc.outNos) : 0,
                  closeQty: lc.closeQty || 0,
                  closeRate: lc.closeQty ? (lc.closeRate && lc.closeNos) ? (lc.closeRate / lc.closeNos) : 0 : 0,
                  closeTotal: (lc.closeRate && lc.closeNos && lc.closeQty) ? lc.closeQty * (lc.closeRate / lc.closeNos) : 0,
                  children: subChild,
                  direction: lc.direction,
                  category: lc.category,
                  category_no: lc.category_no,
                  // details:  await processDetailRecords(lc, index + '-' + i),
                  date: lc.date,
                  color: 'slected-row',
                };
                return processDetailRecords(lc, locationMaster, subLocationMaster, index + '-' + i)
                  .then(detail => {
                    subData['details'] = detail;
                    return subData;
                  })
                //return subData;
              })
            });
          })
          return Promise.all(locationChildren).then(locDatas => {
            return processDetailRecords(doc, locationMaster, subLocationMaster, index)
              .then(dd => {
                return {
                  key: index,
                  sparePart: (doc.sparepart && doc.sparepart.name) || '-',
                  sparePartId: (doc.sparepart && doc.sparepart._id) || null,
                  sparePartType: (doc.sparepartType && doc.sparepartType.name) || '-',
                  unit: doc.unit || '-',
                  location: 'Total',
                  subLocation: '-',
                  openQty: doc.openQty || 0,
                  openRate: doc.openRate || 0,
                  openTotal: doc.openTotal || 0, // (doc.openRate && doc.openQty) ? doc.openQty * doc.openRate : 0,
                  inQty: doc.inQty || 0,
                  inRate: doc.inRate || 0,
                  inTotal: doc.inTotal || 0, // (doc.inRate && doc.inQty) ? doc.inQty * doc.inRate : 0,
                  outQty: doc.outQty || 0,
                  outRate: doc.outRate || 0,
                  outTotal: doc.outTotal || 0, // (doc.outRate && doc.outQty) ? doc.outQty * doc.outRate : 0,
                  closeQty: doc.closeQty || 0,
                  closeRate: doc.closeRate || 0,
                  closeTotal: doc.closeTotal || 0, //  (doc.closeRate && doc.closeQty) ? doc.closeQty * doc.closeRate : 0,
                  color: 'color-row',
                  children: locDatas,
                  details: dd,
                };
              })

          })

        });

    });

    Promise.all(mainDoc).then(result => {
      resolve(result);
    })
  });
}

function processDetailRecords(doc, locationMaster, subMaster, index) {
  // console.log(index, doc);
  let records = [];
  return new Promise(done => {

    records.push({
      key: moment().valueOf() + 'O' + (Math.random() * 9999 + '-' + index),
      date: doc.openDate || '',
      text: 'Opening Balance',
      voucher: '',
      assetId: '',
      assetCode: '',
      location: '-',
      subLocation: '',
      openQty: doc.openQty || 0,
      openRate: (doc.openRate && doc.openNos) ? (doc.openRate / doc.openNos) : 0,
      openTotal: (doc.openRate && doc.openNos && doc.openQty) ? (doc.openQty * (doc.openRate / doc.openNos)) : 0,
      inQty: 0,
      inRate: 0,
      inTotal: 0,
      outQty: 0,
      outRate: 0,
      outTotal: 0,
      closeQty: 0,
      closeRate: 0,
      closeTotal: 0,
    });

    records.push({
      key: moment().valueOf() + 'C' + (Math.random() * 9999 + '-' + index),
      date: doc.closeDate || '',
      text: 'Closing Balance',
      voucher: '',
      assetId: '',
      assetCode: '',
      location: '-',
      subLocation: '',
      openQty: 0,
      openRate: 0,
      openTotal: 0,
      inQty: 0,
      inRate: 0,
      inTotal: 0,
      outQty: 0,
      outRate: 0,
      outTotal: 0,
      closeQty: doc.closeQty || 0,
      closeRate: (doc.closeRate && doc.closeNos) ? (doc.closeRate / doc.closeNos) : 0,
      closeTotal: (doc.closeRate && doc.closeNos && doc.closeQty) ? (doc.closeQty * (doc.closeRate / doc.closeNos)) : 0,

    });
    const docInventories = doc.inventory ? doc.inventory : doc[0] || [];
    let newRecords = (docInventories || []).map((item, inx) => {

      if(['opening', 'closing'].indexOf(item.direction) < 0) {
        const sLocationObj = subMaster.data.filter(l => l._id.toString() === (item.subLocation || '').toString());
        const location = locationMaster.data.filter(l => l._id.toString() === (item.location || '').toString());
        return {
          key: item._id.toString() + ' ' + inx + '-' + index,
          date: item.date || '',
          text: item.category,
          voucher: item.category_no,
          assetId: item.assetId,
          assetCode: item.assetCode,
          location: (location && location[0]) ? location[0].name : '-',
          subLocation: (sLocationObj && sLocationObj[0]) ? sLocationObj[0].name : '-',
          openQty: 0,
          openRate: 0,
          openTotal: 0,
          inQty: item.in_quantity || 0,
          inRate: item.in_rate || 0,
          inTotal: (item.in_quantity * item.in_rate),
          outQty: item.out_quantity || 0,
          outRate: item.out_rate || 0,
          outTotal: (item.out_quantity * item.out_rate),
          closeQty: 0,
          closeRate: 0,
          closeTotal: 0,
        }
      }
    }).filter(item => item !== undefined);

    if(newRecords && newRecords.length > 0)
      records = records.concat(newRecords);

    return done(records);
  })

}

function groupBy(objectArray, property) {
  return new Promise((resolve, reject) => {
    let clients = [];
    resolve(objectArray.reduce((acc, obj) => {
      const key = obj[property];
      if(!acc[key]) {
        acc[key] = {
          openQty: 0,
          openRate: 0,
          openNos: 0,
          closeQty: 0,
          closeRate: 0,
          closeNos: 0,
          inQty: 0,
          inRate: 0,
          inNos: 0,
          outQty: 0,
          outRate: 0,
          outNos: 0
        };
      }
      if(!clients[key])
        clients[key] = [];
      // Add object to list for given key's value

      // acc[key].push(obj);
      let counter = {
        openQty: 0,
        openRate: 0,
        openNos: 0,
        closeQty: 0,
        closeRate: 0,
        closeNos: 0,
        inQty: 0,
        inRate: 0,
        inNos: 0,
        outQty: 0,
        outRate: 0,
        outNos: 0
      };

      if(obj.direction === 'opening') {
        counter['openQty'] = obj.open_quantity || 0;
        counter['openRate'] = obj.open_rate || 0;
        counter['openNos'] = 1;
      }

      if(obj.direction === 'closing') {
        counter['closeQty'] = obj.close_quantity || 0;
        counter['closeRate'] = obj.close_rate || 0;
        counter['closeNos'] = 1;
      }

      if(obj.direction.includes('inwards')) {
        counter['inQty'] = obj.in_quantity || 0;
        counter['inRate'] = obj.in_rate || 0;
        counter['inNos'] = 1;
      }
      if(obj.direction.includes('outwards')) {
        counter['outQty'] = obj.out_quantity || 0;
        counter['outRate'] = obj.out_rate || 0;
        counter['outNos'] = 1;
      }
      clients[key].push(obj);
      acc[key] = {...sumObjectsByKey(acc[key], counter), ...[clients[key]]};
      return acc;
    }, {}));

  })

}

const sumObjectsByKey = (...objs) => {
  const res = objs.reduce((a, b) => {
    for (let k in b) {
      if(b.hasOwnProperty(k))
        a[k] = (a[k] || 0) + b[k];
    }
    return a;
  }, {});
  return res;
}
